import { render, staticRenderFns } from "./NewsPageComponent.vue?vue&type=template&id=5350a2b4&scoped=true&"
import script from "./NewsPageComponent.vue?vue&type=script&lang=js&"
export * from "./NewsPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350a2b4",
  null
  
)

export default component.exports